var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.457,
    height: 12.641,
    viewBox: "0 0 12.457 12.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30496",
    "data-name": "Group 30496",
    transform: "translate(0.25 0.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11759",
    "data-name": "Path 11759",
    d: "M51.146,4.725a1.89,1.89,0,1,1-1.89-1.89A1.89,1.89,0,0,1,51.146,4.725Z",
    transform: "translate(-43.161 -2.583)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11760",
    "data-name": "Path 11760",
    d: "M40.136,58.139h-5a.52.52,0,0,1-.486-.706l.171-.447a1.455,1.455,0,0,1,1.359-.935h2.916a1.455,1.455,0,0,1,1.359.935l.171.447A.52.52,0,0,1,40.136,58.139Z",
    transform: "translate(-31.54 -51.076)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11761",
    "data-name": "Path 11761",
    d: "M13.5,79.682H3.62a.785.785,0,0,0-.778.887l.427,3.25a.785.785,0,0,0,.778.682h9.031a.785.785,0,0,0,.778-.682l.427-3.25A.785.785,0,0,0,13.5,79.682Z",
    transform: "translate(-2.583 -72.609)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.03113711edb8c729673b47ad329430ae.svg";
export { ForwardRef as ReactComponent };